<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-row justify="center">
        <!-- <imageCard 
          v-for="(image, index) in images" :key="index"   
          :image="image"  
        >
        </imageCard> -->
        <v-card
          width ="100%"
          
        >
            <v-carousel 
              :show-arrows="false"
              cycle
              hide-delimiters
              height="320px"
            >
            <v-carousel-item
              v-for="(item,i) in items"
              :key="i"
              :src="item.image"
            ></v-carousel-item>
          </v-carousel>

        </v-card>
        <imageCard 
          v-for="(image, index) in images" :key="index"   
          :image="image"  
        >
        </imageCard>
        </v-row>
      </v-col>
    </v-row>
 </v-container>
</template>

<script>
  // import imageCard  from "@/components/imageCard";
  import imageCard  from "@/components/imageCard";
  import {mapActions } from "vuex";
export default {
  
  name: "Home",
  components: {
     imageCard
  },
  data() {
    return {
      images: [],
      items: []
    }
  }, 
  methods: {
    ...mapActions(['getAll']),
    find() {
      this.getAll().then(result =>{
        result.data.forEach(element => {
          let image = this.src+element.imageName
          this.items.push({image})
        });
        this.images =   result.data;
        this.items.forEach(item => {
          console.log(item)
        })
      }) 
    }
  }, 
  computed: {
    src: function() {
        if(process.env.NODE_ENV === 'production') {
            return "/api/images/image?filename="
        } else {
            return "http://localhost:5000/api/images/image?filename="
        }
    }
  },
  mounted() {
    this.find();
  }
}
</script>

<style>
  .home-page {
    width: 100%;
    height: 100%;
  }
</style>